import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TextMaskModule } from 'angular2-text-mask';

import { SharedModule } from '../shared/shared.module';
import { SskRoutingModule } from './ssk.routing.module';

import { InvalidTicketComponent } from './invalid-ticket/invalid-ticket.component';
import { EnteridComponent } from './enterid/enterid.component';
import { CompleteprofileComponent } from './completeprofile/completeprofile.component';
import { ScanticketComponent } from './scanticket/scanticket.component';
import { ScanAnotherComponent } from './scan-another/scan-another.component';
import { AddprofileComponent } from './addprofile/addprofile.component';
import { EnterEmailComponent  } from './enter-email/enter-email.component';
import { PasswordComponent  } from './password/password.component';
import { SuccessComponent  } from './success/success.component';
import { FinalCompleteComponent  } from './final-complete/final-complete.component';
import { CompletedExitComponent  } from './completed-exit/completed-exit.component';
import { LoginComponent  } from './login/login.component';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    SharedModule,
    SskRoutingModule,
    TextMaskModule  
  ],
  declarations: [ InvalidTicketComponent, EnteridComponent, EnterEmailComponent, 
    CompleteprofileComponent, ScanticketComponent, ScanAnotherComponent, AddprofileComponent, 
    PasswordComponent, SuccessComponent, FinalCompleteComponent, CompletedExitComponent, LoginComponent ]
})

export class SskRoutesModule {}


// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/routes/ssk.module.ts